import 'select2';
import 'select2/dist/css/select2';
import { isEmpty } from 'lodash-es';
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['selectTimeLimit', 'selectClaimsToOpenMeeting', 'selectPaymentMethods', 'professorPresenceRules'];

  connect() {
    this.$ipEnrollmentFeeYes = this.element.querySelector('input#enrollment-fee-yes');
    this.$dvEnrollmentFee = this.element.querySelector('div#enrollment-fee');
    this.bindCollapsables();

    this.element.querySelectorAll('[data-settings]').forEach(($el) => {
      $el.addEventListener('click', () => this.toggleSettings($el));
    });

    this.toggleSettings(this.selectSettingToDisplay());

    $('#settings #fracionada-on').on('change', () => this.element.querySelector('#wrapper-fraction-tuition').classList.toggle('hidden'));
    $('#settings [data-default-value]').on('change', function(ev) {
      ev.preventDefault();
      let $this = $(this);
      const minValue = +this.dataset.minValue;
      const value = this.value < minValue ? minValue : this.value;
      $this.val(isEmpty(value) ? this.dataset.defaultValue : value)
    });

    this.element.querySelectorAll('input[type="checkbox"][data-toggle-collapse]').forEach(($ip) => {
      $ip.addEventListener('change', () => this.collapseOnChecked($ip.dataset.toggleCollapse, $ip));
    });

    this.selectTimeLimitTarget.addEventListener('change', (ev) => this.updateSelectTimeLimit());
    this.selectTimeLimitTarget.dispatchEvent(new Event('change'));

    $(this.selectClaimsToOpenMeetingTarget).select2({
      placeholder: 'Selecione as regras',
      multiple: true,
      allowClear: true,
    });

    $(this.selectPaymentMethodsTargets).select2({
      placeholder: 'Selecione as formas de pagamento',
      allowClear: true,
    });

    $(this.professorPresenceRulesTarget).select2({
      placeholder: 'Selecione uma regra',
      allowClear: false,
    });

    this.element.querySelectorAll('[data-calculation-target]').forEach(($el) => {
      this.updateSymbol($el);
      $el.addEventListener('change', () => this.updateSymbol($el));
    });

    this.enrollmentFeeActions();
    this.fractionalActions();
  }

  updateSymbol($el) {
    if (!$el)
      return;

    let rateSymbol = this.element.querySelector($el.dataset.calculationTarget);

    if (!rateSymbol)
      return;

    rateSymbol.innerHTML = $el.selectedOptions[0].dataset.symbol;
  }

  updateSelectTimeLimit() {
    let isDayBefore = this.selectTimeLimitTarget.value == 'day_before',
      wrapper = this.element.querySelector('#custom-time-limit'),
      input = wrapper.querySelector('input');

    if (isDayBefore) { // hidden
      wrapper.classList.remove('block');
      setTimeout(() => wrapper.classList.add('hidden'), 150);
      input.setAttribute('disabled', 'disabled');
    } else { // block
      wrapper.classList.add('fade');
      wrapper.classList.add('show');
      wrapper.classList.remove('hidden');
      setTimeout(() => wrapper.classList.add('block'), 150);
      input.removeAttribute('disabled');
    }
  }

  selectSettingToDisplay() {
    let firstSetting = this.element.querySelector('[data-settings]'),
      selectedSetting = this.element.querySelector(`[data-settings="${window.location.hash}"]`);

    if (!!selectedSetting && selectedSetting.dataset.hasOwnProperty('turboFrame'))
      selectedSetting.click();

    return selectedSetting || firstSetting;
  }

  toggleSettings($anchor) {
    let settingsSelector = $anchor.dataset.settings;

    this.element.querySelectorAll('[data-settings]').forEach(($el) => $el.querySelector('.title').classList.remove('text-primary'));
    $anchor.querySelector('.title').classList.add('text-primary');

    this.element.querySelectorAll('.settings-tab').forEach(($el) => {
      $el.classList.toggle('hidden', true);
      $el.classList.remove('block', 'fade');
    })
    let $element = this.element.querySelector(`.settings-tab${settingsSelector}`);
    $element.classList.remove('hidden');
    $element.classList.add('fade');
    $element.classList.add('show');
    window.location.hash = settingsSelector;
    setTimeout(() => $element.classList.add('block'), 200);
  }

  enrollmentFeeActions() {
    this.element.querySelectorAll('input#enrollment-fee-no, input#enrollment-fee-yes').forEach(($ip) => {
      $ip.addEventListener('change', () => this.collapseOnChecked(this.$dvEnrollmentFee, this.$ipEnrollmentFeeYes));
    });
    this.collapseOnChecked(this.$dvEnrollmentFee, this.$ipEnrollmentFeeYes);
    $(this.$dvEnrollmentFee).trigger(`${this.$ipEnrollmentFeeYes.checked ? 'shown' : 'hidden' }.bs.collapse`)
  }

  collapseOnChecked(collapsable, input) {
    $(collapsable).collapse(input.checked ? 'show' : 'hide');
  }

  bindCollapsables() {
    $('.collapse')
      .on('hidden.bs.collapse', (ev) => $(ev.currentTarget.querySelectorAll('input')).attr('disabled', true))
      .on('shown.bs.collapse', (ev) => $(ev.currentTarget.querySelectorAll('input')).removeAttr('disabled'));
  }

  fractionalActions() {
    let inputLimit = $('#fractional-tuition');

    $('#fractional-tuition-1, #fractional-tuition-2').each(function() {
      if ($(this).is(':checked'))
        inputLimit.attr('disabled', true)
    }).on('change', function(ev) {
      if (ev.currentTarget.checked)
        inputLimit.attr('disabled', true)
    })

    $('#fracionada-radio').on('change', function(ev) {
      if (ev.currentTarget.checked)
        inputLimit.removeAttr('disabled')
    });
  }
}